import { SimProductAction } from 'products/sim/Actions/constants/simProductActions';
import { authFetch } from 'auth/utils.ts';
import { envVariables } from 'common/utils/envVariables.ts';

export const activateCards = async (props: { euiccIds: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/in-life-changes/activation`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const suspendCards = async (props: { euiccIds: string[] }) => {
  const suspensionActionResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/in-life-changes/suspension`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!suspensionActionResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const unsuspendCards = async (props: { euiccIds: string[] }) => {
  const unsuspensionActionResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/in-life-changes/unsuspension`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!unsuspensionActionResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const terminateCards = async (props: { euiccIds: string[] }) => {
  const terminationActionResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/in-life-changes/termination`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!terminationActionResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const cancelLocationsOfCards = async (props: { euiccIds: string[] }) => {
  const cancelLocationActionResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/in-life-changes/cancel-location`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!cancelLocationActionResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

type GetAvailableActionsForSimProps = {
  euiccs: string[];
};

type ActionAvailability = {
  euicc: string;
  availableManagementActions: SimProductAction[];
};

type AvailableActionsDTO = {
  rsims: ActionAvailability[];
};

export const getAvailableActionsForRSims = async ({ euiccs }: GetAvailableActionsForSimProps) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_RSIM_PRODUCTS_API}/rsim-available-actions`,
    {
      method: 'POST',
      body: JSON.stringify({ euiccs }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const availableActionsDTO: AvailableActionsDTO = await availableActionsResponse.json();

  return availableActionsDTO.rsims.reduce((acc, availableSimActions) => {
    return {
      ...acc,
      [availableSimActions.euicc]: availableSimActions.availableManagementActions,
    };
  }, {} as Record<string, SimProductAction[]>);
};
